import React, { useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { SearchIcon, XIcon } from 'lucide-react';
import { products } from '../../data/products';
import { formatPrice } from '../../utils/currency';
export function SearchBar() {
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (q.length < 2) return [];
    return products.filter(p => `${p.name} ${p.brand} ${p.specs.join(' ')}`.toLowerCase().includes(q)).slice(0, 6);
  }, [query]);
  const showPanel = focused && query.trim().length >= 2;
  return <div className="relative w-full" data-id="element-258" data-mp="bkktgu4yr6i3">
      <label htmlFor="site-search" className="sr-only" data-id="element-259" data-mp="1921cgtmrk3y8">
        Search products
      </label>
      <SearchIcon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-260" data-mp="14at4m2130qn6" />
      <input ref={inputRef} id="site-search" type="search" value={query} onChange={e => setQuery(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setTimeout(() => setFocused(false), 150)} placeholder="Search batteries, power stations, panels…" autoComplete="off" className="h-11 w-full rounded-lg border border-line bg-surface pl-10 pr-10 text-sm text-ink placeholder:text-muted focus:border-ink focus:bg-white focus:outline-none focus:ring-2 focus:ring-ink/10 [&::-webkit-search-cancel-button]:hidden" data-id="element-261" data-mp="c7gdd7vcvnq3" />
      {query && <button type="button" onClick={() => {
      setQuery('');
      inputRef.current?.focus();
    }} aria-label="Clear search" className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-muted hover:bg-line hover:text-ink" data-id="element-262" data-mp="3gnhkx8wdsr19">
          <XIcon className="h-4 w-4" data-id="element-263" data-mp="2rtd1f7n8zz6k" />
        </button>}

      <AnimatePresence data-id="element-264" data-mp="2mt77fktia0lb">
        {showPanel && <motion.div initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-xl border border-line bg-white shadow-[0_16px_40px_-16px_rgba(14,26,36,0.25)]" data-id="element-265" data-mp="2msfigsuez140">
            {results.length === 0 ? <p className="px-4 py-5 text-sm text-muted" data-id="element-266" data-mp="31qhs9ks1gitp">
                No products found for “<span className="font-medium text-ink" data-id="element-267" data-mp="31odco5ks1vdl">{query}</span>”
              </p> : <ul className="py-1.5" data-id="element-268" data-mp="2wpka38713os7">
                {results.map(p => <li key={p.id} data-id="element-269" data-mp="3u83itcaf0imo">
                    <Link to={`/product/${p.id}`} className="flex items-center gap-3 px-3 py-2 hover:bg-surface" onClick={() => setQuery('')} data-id="element-270" data-mp="3pg28hvwt51za">
                      <img src={p.image} alt="" className="h-11 w-11 rounded-md bg-surface object-cover" data-id="element-271" data-mp="5lysc6oiy6kv" />
                      <span className="min-w-0 flex-1" data-id="element-272" data-mp="aixo0tnu6ll6">
                        <span className="block truncate text-sm font-medium text-ink" data-id="element-273" data-mp="ellw2z4q7oh3">{p.name}</span>
                        <span className="block text-xs text-muted" data-id="element-274" data-mp="jkosjv6n4mdg">{p.specs.join(' · ')}</span>
                      </span>
                      <span className="text-sm font-semibold text-ink" data-id="element-275" data-mp="oj001z9gqksi">{formatPrice(p.price)}</span>
                    </Link>
                  </li>)}
              </ul>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}